(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const RESUME_DELAY = 8000;

  class HueSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('.hue-slider__slide'));
      this.dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
      this.prevBtn = root.querySelector('[data-slider-prev]');
      this.nextBtn = root.querySelector('[data-slider-next]');
      this.current = 0;
      this.timer = null;
      this.resumeTimer = null;

      if (this.slides.length <= 1) return;

      this.autoplay = root.dataset.autoplay === 'true' && !prefersReducedMotion;
      this.speed = (parseFloat(root.dataset.speed) || 6) * 1000;

      this.bindEvents();
      this.go(0, { silent: true });

      if (this.autoplay) this.start();
    }

    bindEvents() {
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i);
          this.pauseAndResume();
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.go(this.current - 1);
          this.pauseAndResume();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.go(this.current + 1);
          this.pauseAndResume();
        });
      }

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => {
        if (this.autoplay) this.start();
      });

      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', (e) => {
        if (!this.root.contains(e.relatedTarget) && this.autoplay) this.start();
      });

      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(this.current - 1);
          this.pauseAndResume();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.go(this.current + 1);
          this.pauseAndResume();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stop();
        } else if (this.autoplay) {
          this.start();
        }
      });
    }

    go(index, { silent = false } = {}) {
      const total = this.slides.length;
      const next = ((index % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const isActive = i === next;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        slide.querySelectorAll('a, button').forEach((el) => {
          el.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      });

      this.dots.forEach((dot, i) => {
        const isActive = i === next;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.current = next;
      if (!silent && this.autoplay) this.restart();
    }

    start() {
      this.stop();
      if (this.slides.length <= 1) return;
      this.timer = window.setInterval(() => this.go(this.current + 1, { silent: true }), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      if (this.autoplay) this.start();
    }

    pauseAndResume() {
      this.stop();
      if (this.resumeTimer) window.clearTimeout(this.resumeTimer);
      if (!this.autoplay) return;
      this.resumeTimer = window.setTimeout(() => this.start(), RESUME_DELAY);
    }
  }

  const init = () => {
    document.querySelectorAll('.hue-slider').forEach((el) => {
      if (el.dataset.hueSliderInit === '1') return;
      el.dataset.hueSliderInit = '1';
      new HueSlider(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) init();
  });
})();
